import React from "react";
import { Button } from "@/components/ui/button";
import { Progress } from "@/components/ui/progress";
import { useToast } from "@/components/ui/use-toast";
import { Poll, PollOption } from "@/types/post";
import moment from "moment";

interface PollComponentProps {
  poll: Poll;
  hasVoted: boolean;
  pollResults: { [key: number]: number };
  totalVotes: number;
  onVote: (optionId: number) => Promise<void>;
}

export function PollComponent({
  poll,
  hasVoted,
  pollResults,
  totalVotes,
  onVote,
}: PollComponentProps) {
  if (!poll || !Array.isArray(poll.options)) {
    return null;
  }

  return (
    <div className="mt-4 space-y-3">
      {Array.isArray(poll.options) && poll?.options?.map((option: PollOption) => {
        const optionIdNum = parseInt(option.id);
        const voteCount = pollResults[optionIdNum] || 0;
        const percentage = totalVotes > 0 ? (voteCount / totalVotes) * 100 : 0;
        
        return (
          <div key={option.id} className="space-y-1">
            <Button
              variant={hasVoted ? "ghost" : "outline"}
              className="w-full justify-between"
              onClick={(e: React.MouseEvent) => {
                e.preventDefault();
                e.stopPropagation();
                if (!hasVoted) onVote(optionIdNum);
              }}
              disabled={hasVoted || new Date(poll.endTime) < new Date()}
            >
              <span>{option.text}</span>
              {hasVoted && (
                <span className="text-sm text-muted-foreground">
                  {percentage.toFixed(1)}% ({voteCount})
                </span>
              )}
            </Button>
            {hasVoted && (
              <Progress value={percentage} className="h-2" />
            )}
          </div>
        );
      })}
      
      <div className="flex justify-between text-sm text-muted-foreground mt-2">
        <span>{totalVotes} votes</span>
        {new Date(poll.endTime) < new Date() ? (
          <span>Poll ended {moment(poll.endTime).fromNow()}</span>
        ) : (
          <span>Ends {moment(poll.endTime).fromNow()}</span>
        )}
      </div>
    </div>
  );
}